/*
 * File: WeSpeakTermsOfUse.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on April 9, 2025 at 5:09 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 31, 2025 at 10:08 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const Wrapper = styled.div`
	max-width: 850px !important;
	margin: 0px auto;

	ul,
	li {
		font-size: 1.1rem;
	}
`;
